(function () {
  'use strict';
  function all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function money(cents) { if (window.theme && window.theme.formatMoney) return window.theme.formatMoney(cents); return '$' + (cents / 100).toFixed(2); }
  function showSlide(carousel, index) {
    var slides = all('[data-loom-slide]', carousel);
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    carousel.dataset.loomActive = String(index);
    slides.forEach(function (slide, i) { slide.hidden = i !== index; });
    all('[data-loom-dot]', carousel).forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-pressed', i === index ? 'true' : 'false'); });
  }
  function selection(root) {
    var inputs = all('[data-loom-addon-toggle]:checked:not(:disabled)', root);
    var total = inputs.reduce(function (sum, input) { return sum + Number(input.dataset.price || 0); }, 0);
    var label = root.querySelector('[data-loom-selection]');
    if (label) label.textContent = inputs.length + ' optional add-ons selected · ' + money(total) + ' added to the main product';
  }
  function init(root) {
    all('[data-loom-product]', root || document).forEach(function (product) {
      selection(product);
      all('[data-loom-carousel]', product).forEach(function (carousel) {
        if (carousel.dataset.loomReady) return;
        carousel.dataset.loomReady = 'true';
        showSlide(carousel, 0);
        var start = null;
        carousel.addEventListener('pointerdown', function (e) { if (e.target.closest('input,label,button')) return; start = e.clientX; });
        carousel.addEventListener('pointerup', function (e) { if (start === null) return; var distance = e.clientX - start; start = null; if (Math.abs(distance) > 45) showSlide(carousel, Number(carousel.dataset.loomActive || 0) + (distance < 0 ? 1 : -1)); });
        carousel.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); showSlide(carousel, Number(carousel.dataset.loomActive || 0) + (e.key === 'ArrowRight' ? 1 : -1)); } });
      });
    });
  }
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-loom-dot]');
    if (dot) { showSlide(dot.closest('[data-loom-carousel]'), Number(dot.dataset.loomDot)); return; }
    var videoButton = e.target.closest('[data-loom-video]');
    if (videoButton) { var video = videoButton.parentNode.querySelector('video'); if (video.paused) { video.play().catch(function () {}); videoButton.textContent = 'Pause video'; videoButton.setAttribute('aria-label', 'Pause video'); } else { video.pause(); videoButton.textContent = 'Play video'; videoButton.setAttribute('aria-label', 'Play video'); } }
  });
  document.addEventListener('change', function (e) { if (e.target.matches('[data-loom-addon-toggle]')) selection(e.target.closest('[data-loom-product]')); });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-loom-form]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (form.dataset.loomBusy) return;
    var product = form.closest('[data-loom-product]');
    var button = form.querySelector('[type=submit]');
    var label = button.querySelector('[data-loom-atc-label]');
    var error = form.querySelector('[data-loom-error]');
    var mainId = Number(form.querySelector('[name=id]').value);
    var mainQty = Math.max(1, Number(form.querySelector('[name=quantity]').value || 1));
    if (!mainId) { error.textContent = 'This product is not available in the store.'; error.hidden = false; return; }
    var items = [{ id: mainId, quantity: mainQty }];
    var seen = {}; seen[mainId] = true;
    all('[data-loom-addon-toggle]:checked:not(:disabled)', product).forEach(function (input) { var id = Number(input.value); if (id && !seen[id]) { items.push({ id: id, quantity: 1 }); seen[id] = true; } });
    form.dataset.loomBusy = 'true'; button.disabled = true; label.textContent = 'ADDING…'; error.hidden = true;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add the selected products.'); return data; }); })
      .then(function () { return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('Products added. Open the cart to see your items.'); return r.json(); }); })
      .then(function (cart) {
        all('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = !cart.item_count; });
        all('[data-cart-count-text]').forEach(function (el) { el.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items'); });
        if (window.theme && window.theme.refreshDrawer && document.getElementById('CartDrawer')) { return window.theme.refreshDrawer().then(function () { window.theme.openDrawer(); }); }
        window.location.assign(root + 'cart');
      })
      .catch(function (err) { error.textContent = err.message; error.hidden = false; })
      .finally(function () { delete form.dataset.loomBusy; button.disabled = false; label.textContent = 'ADD TO CART'; });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
